import { useCallback, useEffect, useMemo, useState } from "react"

import { Modal } from "antd"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router"
import { useNavigate } from "react-router-dom"

import Table from "../../../../Components/Table"
import Creators from "../../reducer"
import { usePageQuery } from "../../usePageQuery"
import { linkUsersColumns } from "../Table/columns"

const pageSize = 10
const UsersModal = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { pathname, search } = useLocation()
  const { openLinkID } = usePageQuery(search)
  const [pageNumber, setPageNumber] = useState(1)
  const [ordering, setOrdering] = useState(null)

  const { fetchingUsers, users } = useSelector((state) => state.marketing)
  const isMobile = useSelector((state) => state.nav.isMobile)
  const { count, results } = users

  const open = !!openLinkID

  const updateInfo = () => {
    if (!openLinkID) return
    const data = {
      id: openLinkID,
      page: pageNumber,
      page_size: pageSize,
      ordering
    }
    dispatch(Creators.getLinkUsersRequest({ ...data }))
  }

  useEffect(() => {
    updateInfo()
  }, [ordering, pageNumber, openLinkID])

  const handleCloseModal = () => {
    navigate(pathname, { replace: true })
    dispatch(
      Creators.marketingSetProp("users", {
        count: 0,
        next: null,
        previous: null,
        results: []
      })
    )
  }

  const tableSettings = useMemo(
    () => ({
      scroll: {
        x: "100%",
        scrollToFirstRowOnChange: true
      },
      pagination: {
        total: count,
        current: pageNumber,
        pageSize: pageSize
      }
    }),
    [count, pageNumber]
  )

  const handleChangeTable = useCallback((pagination, filters, sorter) => {
    let ordering = null
    if (sorter) {
      if (Array.isArray(sorter)) {
        ordering = sorter
          ?.map(({ field, order }) => (order === "ascend" ? field : `-${field}`))
          .join(",")
      } else {
        if (sorter.order) {
          ordering = sorter.order === "ascend" ? sorter.field : `-${sorter.field}`
        }
      }
    }
    setPageNumber(pagination.current)
    setOrdering(ordering)
  }, [])

  return (
    <Modal
      open={open}
      centered={!isMobile}
      width={950}
      title="Users list"
      footer={null}
      closable="true"
      onCancel={handleCloseModal}
      destroyOnClose
      classNames={{ content: "clear-bg" }}
    >
      <Table
        columns={linkUsersColumns}
        loading={fetchingUsers}
        dataSource={results}
        scroll={tableSettings.scroll}
        onChange={handleChangeTable}
        pagination={tableSettings.pagination}
        showSizeChanger={false}
      />
    </Modal>
  )
}

export default UsersModal
